import React from 'react';
import PropTypes from 'prop-types';
import Message, {getMessage} from '../common/Message';
import Countries, {states} from 'epic-diesel-form/src/constants/Countries';
import Select from 'epic-diesel-form/src/components/form/Select';
import Input from 'epic-diesel-form/src/components/form/Input';
import TaxIdInputComponent from '../form/TaxIdInputComponent';
import FileInput from '../form/FileInput';
import getInfluencersFlowSchema from '../../data/InfluencersFlowSchema';
import styles from './Tax.pcss';

const INDIVIDUAL = 'INDIVIDUAL';
const SSN = 'SSN';
const EIN = 'EIN';

export default class Tax extends React.Component {
    static propTypes = {
        messages: PropTypes.object.isRequired,
        form: PropTypes.object,
        trigger: PropTypes.func,
        disabled: PropTypes.bool
    };

    onChange = event => {
        const {name, value} = event.target;
        this.props.trigger(name, value);
    };

    render() {
        const {disabled} = this.props;
        const {messages, form, trigger} = this.props;
        const taxInfoSchema = getInfluencersFlowSchema(getMessage, messages).taxInfo;
        console.log(taxInfoSchema);
        const options = [
            {value: false, label: getMessage(messages, 'epic.affiliate.settings.tax_us')},
            {value: true, label: getMessage(messages, 'epic.affiliate.settings.tax_non_us')}
        ];
        const businessTypes = [
            {
                label: getMessage(messages, 'epic.affiliate.settings.tax.business_types.none'),
                value: ''
            },
            {
                label: getMessage(
                    messages,
                    'epic.affiliate.settings.tax.business_types.individual'
                ),
                value: INDIVIDUAL
            },
            {
                label: getMessage(
                    messages,
                    'epic.affiliate.settings.tax.business_types.c_corporation'
                ),
                value: 'CCORP'
            },
            {
                label: getMessage(
                    messages,
                    'epic.affiliate.settings.tax.business_types.s_corporation'
                ),
                value: 'SCORP'
            },
            {
                label: getMessage(
                    messages,
                    'epic.affiliate.settings.tax.business_types.partnership'
                ),
                value: 'PARTNERSHIP'
            },
            {
                label: getMessage(messages, 'epic.affiliate.settings.tax.business_types.trust'),
                value: 'TRUST'
            },
            {
                label: getMessage(messages, 'epic.affiliate.settings.tax.business_types.llc'),
                value: 'LLC'
            },
            {
                label: getMessage(messages, 'epic.affiliate.settings.tax.business_types.other'),
                value: 'OTHER'
            }
        ];
        const stateOptions = [{value: '', label: 'State or Province *'}].concat(states);
        const isForeign = form.foreignTax;
        const countryOptions = isForeign ? Countries.slice(1) : Countries.slice(0, 1);
        let taxTypes;
        let {taxType} = form;
        let taxTypeRequired = true;
        let taxIdRequired = true;
        if (!isForeign) {
            taxTypes = [{label: 'None', value: ''}];
            if (form.businessType === INDIVIDUAL) {
                taxTypes.push({
                    label: getMessage(messages, 'epic.affiliate.settings.tax.business_types.ssn'),
                    value: SSN
                });
                if (!taxTypes.find(item => item.value === form.taxType)) {
                    taxType = 'SSN';
                }
            } else {
                taxTypes.push({
                    label: getMessage(messages, 'epic.affiliate.settings.tax.business_types.ein'),
                    value: EIN
                });
                if (!taxTypes.find(item => item.value === form.taxType)) {
                    taxType = 'EIN';
                }
            }
        } else {
            taxTypes = [
                {
                    label: getMessage(messages, 'epic.affiliate.settings.tax.business_types.none'),
                    value: ''
                },
                {
                    label: getMessage(messages, 'epic.affiliate.settings.tax.business_types.vat'),
                    value: 'VAT'
                },
                {
                    label: getMessage(
                        messages,
                        'epic.affiliate.settings.tax.business_types.tax_id'
                    ),
                    value: 'TAXID'
                }
            ];
            if (!isForeign && form.businessType === INDIVIDUAL) {
                taxTypeRequired = false;
                taxIdRequired = false;
            }
            if (!taxTypes.find(item => item.value === form.taxType)) {
                taxType = '';
            }
        }

        return (
            <div className={styles.section}>
                <div className={styles.title}>
                    <Message code="epic.affiliate.settings.tax_title" />
                </div>
                <div className={styles.desc}>
                    <Message code="epic.affiliate.settings.tax_description" />
                </div>
                <div className={styles.row}>
                    <div>
                        <Select
                            required
                            name={taxInfoSchema.foreignTax.identifier}
                            value={form.foreignTax}
                            validationErrors={taxInfoSchema.foreignTax.validationMessages}
                            options={options}
                            disabled={disabled}
                            onChange={trigger}
                        />
                    </div>
                    <div>
                        <Input
                            name={taxInfoSchema.businessName.identifier}
                            value={form.businessName || ''}
                            required={false}
                            placeholder={taxInfoSchema.businessName.display.text}
                            onChange={this.onChange}
                            disabled={disabled}
                        />
                    </div>
                    <div>
                        <Input
                            name={taxInfoSchema.nameOnTaxId.identifier}
                            value={form.legalName || ''}
                            required={!disabled}
                            placeholder={taxInfoSchema.nameOnTaxId.display.text}
                            onChange={this.onChange}
                            disabled={disabled}
                        />
                    </div>
                    <div>
                        <Select
                            required
                            name={taxInfoSchema.businessType.identifier}
                            validationErrors={taxInfoSchema.businessType.validationMessages}
                            value={form.businessType}
                            options={businessTypes}
                            onChange={trigger}
                            disabled={disabled}
                        />
                    </div>
                    <div>
                        <Select
                            name={taxInfoSchema.taxType.identifier}
                            validationErrors={taxInfoSchema.taxType.validationMessages}
                            value={taxType}
                            options={taxTypes}
                            required={taxTypeRequired}
                            onChange={trigger}
                            disabled={disabled}
                        />
                    </div>
                    {taxType && (
                        <div>
                            <TaxIdInputComponent
                                taxType={taxType}
                                value={form.taxId || ''}
                                messages={messages}
                                onChange={this.onChange}
                                required={taxIdRequired}
                                disabled={disabled}
                            />
                        </div>
                    )}

                    <div>
                        <Input
                            name={taxInfoSchema.address.identifier}
                            value={form.street || ''}
                            required={!disabled}
                            placeholder={taxInfoSchema.address.display.text}
                            validations={taxInfoSchema.address.validations}
                            validationErrors={taxInfoSchema.address.validationMessages}
                            onChange={this.onChange}
                            disabled={disabled}
                        />
                    </div>
                    <div>
                        <Input
                            name={taxInfoSchema.city.identifier}
                            value={form.city || ''}
                            required={!disabled}
                            placeholder={taxInfoSchema.city.display.text}
                            validations={taxInfoSchema.city.validations}
                            validationErrors={taxInfoSchema.city.validationMessages}
                            onChange={this.onChange}
                            disabled={disabled}
                        />
                    </div>

                    {!isForeign && (
                        <div>
                            <Select
                                name={taxInfoSchema.state.identifier}
                                value={form.state || ''}
                                required={!isForeign && !disabled}
                                placeholder={taxInfoSchema.state.display.text}
                                validations={taxInfoSchema.state.validations}
                                validationErrors={taxInfoSchema.state.validationMessages}
                                options={stateOptions}
                                disabled={disabled}
                                onChange={trigger}
                            />
                        </div>
                    )}
                    {!isForeign && (
                        <div>
                            <Input
                                name={taxInfoSchema.zip.identifier}
                                value={form.zip || ''}
                                required={!isForeign && !disabled}
                                placeholder={taxInfoSchema.zip.display.text}
                                validations={taxInfoSchema.zip.validations}
                                validationErrors={taxInfoSchema.zip.validationMessages}
                                onChange={this.onChange}
                                disabled={disabled}
                            />
                        </div>
                    )}
                    {isForeign && (
                        <div>
                            <Input
                                name={taxInfoSchema.region.identifier}
                                value={form.state}
                                required={!isForeign && !disabled}
                                placeholder={taxInfoSchema.region.display.text}
                                validations={taxInfoSchema.region.validations}
                                validationErrors={taxInfoSchema.region.validationMessages}
                                onChange={this.onChange}
                                disabled={disabled}
                            />
                        </div>
                    )}

                    {isForeign && (
                        <div>
                            <Input
                                name={taxInfoSchema.postalCode.identifier}
                                value={form.zip}
                                required={!isForeign && !disabled}
                                placeholder={taxInfoSchema.postalCode.display.text}
                                validations={taxInfoSchema.postalCode.validations}
                                validationErrors={taxInfoSchema.postalCode.validationMessages}
                                onChange={this.onChange}
                                disabled={disabled}
                            />
                        </div>
                    )}

                    <div>
                        <Select
                            required
                            name={taxInfoSchema.country.identifier}
                            value={form.country}
                            onChange={trigger}
                            options={countryOptions}
                            validationErrors={taxInfoSchema.country.validationMessages}
                            disabled={disabled}
                        />
                    </div>
                </div>
                {!disabled && !isForeign && (
                    <span>
                        <div className={styles.file}>
                            <FileInput
                                name={taxInfoSchema.w9form.identifier}
                                errorClass={styles.fileError}
                                value={form.w9form}
                                onChange={trigger}
                                text={taxInfoSchema.w9form.display.text}
                                validations={taxInfoSchema.w9form.validations}
                                validationErrors={taxInfoSchema.w9form.validationMessages}
                                disabled={disabled}
                                required={!isForeign}
                            />
                        </div>
                        <div className={styles.terms}>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: getMessage(
                                        messages,
                                        'ui.message.taxInfo.w9.additionalInfo'
                                    )
                                }}
                            />
                        </div>
                    </span>
                )}
            </div>
        );
    }
}
